import { deDE, enUS } from "@clerk/localizations";
import { deDE as deDEMuiLocalization, enUS as enUSMuiLocalization } from "@mui/material/locale";
import { deDE as deDEDataGrid, enUS as enUSDataGrid } from "@mui/x-data-grid/locales";
import { deDE as deDEDatePicker, enUS as enUSDatePicker } from "@mui/x-date-pickers/locales";

import { SupportedLanguage, SupportedLanguagesCode } from "./types";

export const FALLBACK_LANGUAGE_CODE = SupportedLanguagesCode.deDE;
export const FALLBACK_SUPPORTED_LANGUAGE: Required<SupportedLanguage> = {
  code: SupportedLanguagesCode.deDE,
  name: "Deutsch",
  shortName: "DE",
  xDatePickersLocale: deDEDatePicker.components.MuiLocalizationProvider.defaultProps.localeText,
  muiLocalization: deDEMuiLocalization,
  dataGridLocalization: deDEDataGrid,
  clerkLocalization: deDE,
};

export const supportedLanguages: SupportedLanguage[] = [
  FALLBACK_SUPPORTED_LANGUAGE,
  {
    code: FALLBACK_LANGUAGE_CODE,
    name: "English",
    shortName: "EN",
    xDatePickersLocale: enUSDatePicker.components.MuiLocalizationProvider.defaultProps.localeText,
    muiLocalization: enUSMuiLocalization,
    dataGridLocalization: enUSDataGrid,
    clerkLocalization: enUS,
  },
];
